import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Head from 'next/head';
import { ConfigurationSchema } from 'frontastic-common';

export const CategorySchema = (props) => {
  const { node, name, url, description, metaCategoryName } = props;

  const context = useSelector((state) => state.app.context);
  const storeUrl = context.projectConfiguration['EXTENSION_PUBLIC_URL'];

  const projectSchema = new ConfigurationSchema(
    context.projectConfigurationSchema,
    context.projectConfiguration,
  );

  const pageTitleSuffixSchema = projectSchema.get('frontasticPageTitleSuffix');
  const pageTitleSuffix =
    pageTitleSuffixSchema?.[context.locale] ||
    pageTitleSuffixSchema?.['en_AU@AUD'] ||
    pageTitleSuffixSchema;

  const pageFallbackDescriptionSuffixSchema = projectSchema.get(
    'pageFallbackDescriptionSuffix',
  );
  const pageFallbackDescriptionSuffix =
    pageFallbackDescriptionSuffixSchema?.[context.locale] ||
    pageFallbackDescriptionSuffixSchema;

  const pageTitleIsSetOnNode =
    node.configuration?.seoTitle?.length > 0 && typeof node.configuration?.seoTitle !== 'undefined';
  const pageDescriptionIsSetOnNode =
    node.configuration?.seoDescription?.length > 0 && typeof node.configuration?.seoDescription !== 'undefined';

  const countryName =
    context.locale === 'en_AU@NZD' ? 'New Zealand' : 'Australia';
  const metaTitle = `Buy ${metaCategoryName || node.name} Online in ${countryName}${pageTitleSuffix}`;
  const metaDescription = `Discover the latest in ${
    metaCategoryName || node.name
  } online in ${countryName} at ${context.project.name.toUpperCase()}.${
    pageFallbackDescriptionSuffix ? ` ${pageFallbackDescriptionSuffix}` : ''
  }`;

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'CollectionPage',
    name: name,
    url: `${storeUrl}${url}`,
    description: description,
  };

  useEffect(() => {
    const title = document.querySelector('title');
    if (title && node?.name) {
      title.innerText = pageTitleIsSetOnNode ? `${node.configuration?.seoTitle}${pageTitleSuffix}` : metaTitle;
    }
  }, [node, metaTitle]);

  return (
    <>
      <Head>
        {!pageTitleIsSetOnNode
          ? <title>{metaTitle || name }</title>
          : <title>{name}</title> }
        {!pageDescriptionIsSetOnNode && (
          <meta name="description" content={metaDescription || description} />
        )}

        <meta property="og:url" content={storeUrl + url} />
        <meta property="og:image" content={`${storeUrl}/logo.png`} />
        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content={
            projectSchema.get('schemaOrgName')?.[context.locale] ||
            projectSchema.get('schemaOrgName')
          }
        />
        <meta property="og:locale" content="en-AU" />
        <meta property="og:title" content={metaTitle || name} />
        <meta
          property="og:description"
          content={metaDescription || description}
        />
        <meta property="og:country-name" content="au" />
      </Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </>
  );
};
